import { BadgeVariant } from '@Components';

const CONTRACT_STATUS_VARIANT: Record<string, BadgeVariant> = {
  active: 'green',
  ended: 'gray',
};

const getContractStatusVariant = (status: string): BadgeVariant => CONTRACT_STATUS_VARIANT[status] ?? 'gray';

const isKnownContractStatus = (status: string): boolean => status in CONTRACT_STATUS_VARIANT;

const UPPERCASE_LABEL_CLASS_NAME = 'text-[11px] font-bold uppercase tracking-wide text-gray-500';

const TABLE_SURFACE_CLASS_NAME = 'overflow-hidden rounded-xl border border-gray-200 bg-white';
const TABLE_HEADER_CELL_CLASS_NAME = `border-t-0 ${UPPERCASE_LABEL_CLASS_NAME}`;

// Header and filter bands that replace PageWrapper on the Field Services and Schedules pages.
const PAGE_BAND_CLASS_NAME = 'border-b border-gray-200 px-4 sm:px-7';
const PAGE_HEADER_BAND_CLASS_NAME = `${PAGE_BAND_CLASS_NAME} py-4`;
const PAGE_FILTER_BAND_CLASS_NAME = `${PAGE_BAND_CLASS_NAME} py-3`;

type FieldServiceAvailabilityMode = 'daily' | 'weekly' | 'monthly';

const AVAILABILITY_MODES: FieldServiceAvailabilityMode[] = ['daily', 'weekly', 'monthly'];

const isKnownAvailabilityMode = (mode: string): mode is FieldServiceAvailabilityMode =>
  (AVAILABILITY_MODES as string[]).includes(mode);

const FIELD_SERVICE_TASK_TYPE_CODES = ['pog', 'price', 'shelf', 'promoae', 'promo'];

const isKnownTaskType = (code: string): boolean => FIELD_SERVICE_TASK_TYPE_CODES.includes(code);

interface FieldServiceRetailer {
  id: string;
  name: string;
  short: string;
  color: string;
}

const FIELD_SERVICE_RETAILERS: FieldServiceRetailer[] = [
  { id: 'exito', name: 'Éxito', short: 'ÉX', color: '#E5A800' },
  { id: 'carulla', name: 'Carulla', short: 'CAR', color: '#00843D' },
  { id: 'target', name: 'Target', short: 'TGT', color: '#CC0000' },
  { id: 'kroger_datadirect', name: 'Kroger', short: 'KR', color: '#0060A9' },
];

const RETAILER_BY_ID: Record<string, FieldServiceRetailer> = Object.fromEntries(
  FIELD_SERVICE_RETAILERS.map((retailer) => [retailer.id, retailer]),
);

const getRetailerName = (id: string): string => RETAILER_BY_ID[id]?.name ?? id;
const getRetailerShort = (id: string): string => RETAILER_BY_ID[id]?.short ?? id.slice(0, 3).toUpperCase();
const getRetailerColor = (id: string): string => RETAILER_BY_ID[id]?.color ?? '#667085';

export {
  FIELD_SERVICE_RETAILERS,
  getContractStatusVariant,
  getRetailerColor,
  getRetailerName,
  getRetailerShort,
  isKnownAvailabilityMode,
  isKnownContractStatus,
  isKnownTaskType,
  PAGE_FILTER_BAND_CLASS_NAME,
  PAGE_HEADER_BAND_CLASS_NAME,
  TABLE_HEADER_CELL_CLASS_NAME,
  TABLE_SURFACE_CLASS_NAME,
  UPPERCASE_LABEL_CLASS_NAME,
};
export type { FieldServiceAvailabilityMode };
